module.exports = __webpack_public_path__ + "img/c08_buildingtechvanishaste_Normal_ua.3da68dea.webp";